<div class="retailer-list">
    <div class="add-new-button">
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'plus'"
            [label]="'retailerList.button.new' | translate"
            (click)="openAddRetailerDialog()"
        ></app-button>
    </div>
    <table mat-table [dataSource]="currentRetailerItems" class="mat-elevation-z0" matSort (matSortChange)="sortChange($event)">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"retailerList.column.id" | translate}}</th>
            <td mat-cell *matCellDef="let retailer"> {{retailer.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"retailerList.column.name" | translate}}</th>
            <td mat-cell *matCellDef="let retailer"> {{retailer.name}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"retailerList.column.email" | translate}}</th>
            <td mat-cell *matCellDef="let retailer"> {{retailer.email}} </td>
        </ng-container>

        <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"retailerList.column.location" | translate}}</th>
            <td mat-cell *matCellDef="let retailer"> {{retailer.location}} </td>
        </ng-container>

        <ng-container matColumnDef="retailerOptions.currencyOptions.currency">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"retailerList.column.currency" | translate}}</th>
            <td mat-cell *matCellDef="let retailer"> {{retailer.retailerOptions.currencyOptions.currency}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{"retailerList.column.action" | translate}}</th>
            <td mat-cell *matCellDef="let retailer">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.copy' | translate"
                            (click)="openCopyRetailerDialog(retailer)">
                        <mat-icon class="icon">content_copy</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.button.editJson' | translate"
                            (click)="openEditRetailerJsonDialog(retailer)">
                        <mat-icon class="icon">data_object</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.button.editForm' | translate"
                            (click)="openEditRetailerFormDialog(retailer)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.apikey' | translate"
                            (click)="getRetailerApiKey(retailer.id)">
                        <mat-icon class="icon">lock</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <div>
        <p>{{ 'retailerList.resultCount' | translate : { count: count } }}</p>
        <button [disabled]="currentPage <= 0" (click)="paginate(currentPage - 1)">Vorige</button>
        <button [disabled]="!hasNextPage" (click)="paginate(currentPage + 1)">Volgende</button>
        <select [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
        </select>
    </div>
</div>

